export enum CoreHttpHeaders {
  Cookie = 'Cookie',
  Referrer = 'Referrer',
  UserAgent = 'User-Agent',
  XBrowserSessionId = 'X-Browser-Session-ID',
  XCallerClientId = 'X-Caller-Client-ID',
  XClientVersion = 'X-Client-Version',
  XCookieId = 'X-Cookie-ID',
  XHeaderCsrfToken = 'X-Header-CSRF-Token',
  XKountSessionId = 'X-Kount-Session-ID',
  XMemberIdentityAssertionToken = 'X-Member-Identity-Assertion-Token',
  XOriginatingApplicationId = 'X-Originating-Application-ID',
  XOriginatingIp = 'X-Originating-IP',
  XOriginatingReferrer = 'X-Originating-Referrer',
  XOriginatingUrl = 'X-Originating-URL',
  XOriginatingUserAgent = 'X-Originating-User-Agent',
  XPageviewId = 'X-Pageview-ID',
  XReferringCallerClientId = 'X-Referring-Caller-Client-ID',
  XRequestId = 'X-Request-ID',
  XTestState = 'X-Test-State',
  XVisitorToken = 'X-Visitor-Token',
  XVisitorIdentityAssertionToken = 'X-Visitor-Identity-Assertion-Token',
  XClientPlatform = 'X-Client-Platform',
}

export enum AdditionalHttpHeaders {
  UserAgent = 'User-Agent',
}

export enum CoreHttpCookies {
  AccessToken = 'access_token',
  CookieId = 'cookie_id',
  JwtAccessToken = 'jwt_access_token',
  CsrfToken = 'csrf_token',
  TestState = 'test_state',
  VisitorToken = 'visitor_token',
  VisitorAssertionToken = 'visitor_identity_assertion_token',
  NWSessionToken = 'nw_session_token',
}

export enum AssertionTokenCookies {
  Member = 'member_identity_assertion_token',
  Visitor = 'visitor_identity_assertion_token',
}
